export enum TraitementTransaction {
    EN_ENTENTE = 'en-attente',
    ACQUITER = 'reçu',
    ACCEPTER = 'accepté',
    REJETER = 'rejeté',
    REFUSER = 'refusé',
    ABANDONNER = 'abandonné',
    PARTIEL = 'partiel',
    TOTAL = 'total',
}
